import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoColaboradoresImportarComponent {
  constructor($state) {
    this.$state = $state
    this.completado = false
    this.rawData = null
    this.step = 1
    this.idProyecto = undefined
  }

  actualizar(data) {
    this.completado = this.rawData.length === data.length
  }

  cerrar() {
    this.$state.go('proyecto.colaboradores.lista', {idProyecto: this.idProyecto})
  }

  importar() {
    this.step = 2
  }
}

module.component('fanProyectoColaboradoresImportar', {
  controller: FanProyectoColaboradoresImportarComponent,
  template: template,
  bindings: {
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/importar/component.js